export default "__VITE_ASSET__DVaflhSg__ 400w, __VITE_ASSET__PZ8z9Mkk__ 800w, __VITE_ASSET__L4fbDnlY__ 1024w";